var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action button",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.10391,
    y: 1.05313,
    width: 22.8,
    height: 22.8,
    rx: 2.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1927 10.5358C20.1927 10.2221 20.068 9.9213 19.8462 9.69949C19.6244 9.47767 19.3236 9.35305 19.0099 9.35305H16.6443V6.98748C16.6443 6.67378 16.5197 6.37293 16.2979 6.15112C16.076 5.9293 15.7752 5.80469 15.4615 5.80469H5.9992C5.6855 5.80469 5.38465 5.9293 5.16284 6.15112C4.94102 6.37293 4.81641 6.67378 4.81641 6.98748V16.4498C4.81675 16.561 4.84848 16.67 4.90794 16.764C4.9674 16.858 5.05218 16.9334 5.15255 16.9814C5.25292 17.0294 5.36479 17.0482 5.47533 17.0355C5.58586 17.0228 5.69057 16.9791 5.77742 16.9096L8.36477 14.8235V17.0412C8.36477 17.3549 8.48939 17.6557 8.7112 17.8775C8.93302 18.0994 9.23387 18.224 9.54756 18.224H16.4661L19.2316 20.458C19.3363 20.5426 19.4667 20.589 19.6013 20.5895C19.7581 20.5895 19.9085 20.5272 20.0194 20.4163C20.1304 20.3054 20.1927 20.155 20.1927 19.9982V10.5358ZM17.0472 17.1728C16.9425 17.0881 16.8122 17.0417 16.6776 17.0412H9.54756V14.6756H15.4615C15.7752 14.6756 16.076 14.551 16.2979 14.3292C16.5197 14.1074 16.6443 13.8065 16.6443 13.4928V10.5358H19.0099V18.7599L17.0472 17.1728Z",
    fill: "#0B6D76"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.10391,
    y: 1.05313,
    width: 22.8,
    height: 22.8,
    rx: 2.4,
    stroke: "#0B6D76",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDisabled);
export default __webpack_public_path__ + "static/media/chat_disabled.1ae4dccf714f64f3a282df5eff32b9ff.svg";
export { ForwardRef as ReactComponent };